import { render, staticRenderFns } from "./TreeSidebar.vue?vue&type=template&id=4d3a1c40&scoped=true&"
import script from "./TreeSidebar.vue?vue&type=script&lang=js&"
export * from "./TreeSidebar.vue?vue&type=script&lang=js&"
import style0 from "./TreeSidebar.vue?vue&type=style&index=0&id=4d3a1c40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3a1c40",
  null
  
)

export default component.exports